export default "__VITE_ASSET__D0b$SpLH__"